import {urlEncoder} from "../../../core/utils/url";

export const GiftCardsIndex = {
    mixins: [urlEncoder],
    data() {
        return {
            terms: [],
        }
    },
    computed: {
        filteredCards() {
            return this.giftCards.content.data
                .filter(card => card.types.length)
                .map(card => {
                    card.encoded_id = this.encode(card.id);
                    card.types = card.types.filter(type => type.image);
                    card.display = card.types[Math.floor(Math.random() * card.types.length)];
                    card.terms = this.terms.find(term =>
                        term.url ===
                        `https://magetsi.co.zw/gift-cards/purchase/${card.encoded_id}`
                    );

                    return card;
                })
        }
    },
   /* mounted() {
        window.axios
            .get('/gift-cards/config/terms')
            .then(({data}) => this.terms = data.body.terms);
    }*/
}
